import { render, staticRenderFns } from "./SoldProductsTable.vue?vue&type=template&id=f84766f8&"
import script from "./SoldProductsTable.vue?vue&type=script&lang=js&"
export * from "./SoldProductsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports